export * from './lib/shared-transloco.module';
export * from './lib/transloco-config-factory';
export * from './lib/transloco.service';
